// Univers de l'accueil (v64) : onglets Nouveautés / Top ventes / Promotions (sections/univers-tabs)
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 1200));
const SKELETON = '<div class="univers__skeleton" aria-hidden="true"><span></span><span></span><span></span><span></span></div>';

class UniversTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = $$('[role="tab"]', this);
    this.blocks = $$('.univers__block', this);
    this.limit = Number(this.dataset.limit || 10);
    this.loads = {};
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(tab.dataset.tab, true));
      tab.addEventListener('pointerenter', () => this.load(tab.dataset.tab), { passive: true });
      tab.addEventListener('keydown', (e) => {
        const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!d) return;
        e.preventDefault();
        const next = this.tabs[(i + d + this.tabs.length) % this.tabs.length];
        next.focus();
        this.select(next.dataset.tab, false);
      });
    });
    if (this.hasAttribute('data-sticky')) this.watchHeader();
    // Onglets suivants préparés pendant que la page est au repos, dès que la section approche de l'écran
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      idle(() => { this.load('top'); this.load('promo'); });
    }, { rootMargin: '600px 0px' });
    io.observe(this);
  }

  watchHeader() {
    const hdr = document.querySelector('.header-wrapper--sticky');
    const sec = hdr && hdr.closest('.shopify-section');
    if (!sec) return;
    const set = () => this.style.setProperty('--ut-top', `${sec.offsetHeight + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ann-h')) || 0)}px`);
    new ResizeObserver(set).observe(sec);
    set();
  }

  select(tab, fromClick) {
    if (this.dataset.tab === tab) return;
    this.dataset.tab = tab;
    this.tabs.forEach((t) => {
      const on = t.dataset.tab === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    const panels = this.querySelector('[role="tabpanel"]');
    const current = this.tabs.find((t) => t.dataset.tab === tab);
    if (panels && current) panels.setAttribute('aria-labelledby', current.id);
    this.load(tab).then(() => this.refreshEmpty());
    this.refreshEmpty();
    // Barre collée en haut : on remonte au premier univers pour montrer le nouvel onglet depuis le début
    if (fromClick && this.getBoundingClientRect().top < 0) {
      const y = window.scrollY + this.getBoundingClientRect().top - (parseFloat(this.style.getPropertyValue('--ut-top')) || 0);
      window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  load(tab) {
    if (tab === 'new' || !tab) return Promise.resolve();
    if (this.loads[tab]) return this.loads[tab];
    const section = tab === 'promo' ? 'univers-promos' : 'univers-cards';
    this.loads[tab] = Promise.all(this.blocks.map(async (block) => {
      const panel = block.querySelector(`[data-panel="${tab}"]`);
      if (!panel) return;
      panel.innerHTML = SKELETON;
      const url = block.dataset.url;
      try {
        const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${section}&sort_by=best-selling`);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const root = doc.querySelector('.shopify-section') || doc.body;
        $$('.slider__slide:not(.univers__end-slide)', root).forEach((s, i) => { if (i >= this.limit) s.remove(); });
        const title = block.querySelector('.univers__title');
        $$('[data-end-sub]', root).forEach((s) => { if (title) s.textContent = title.textContent; });
        if (tab === 'promo' && this.dataset.promoUrl) $$('.univers__end', root).forEach((a) => { a.href = this.dataset.promoUrl; });
        panel.replaceChildren(...root.childNodes);
        block.toggleAttribute(`data-empty-${tab}`, !!panel.querySelector('[data-univers-empty]'));
      } catch (e) {
        delete this.loads[tab];
        panel.innerHTML = '';
        block.setAttribute(`data-empty-${tab}`, '');
      }
    }));
    return this.loads[tab];
  }

  refreshEmpty() {
    const tab = this.dataset.tab;
    const msg = this.querySelector('.univers__empty');
    if (msg) msg.hidden = !(tab === 'promo' && this.loads.promo && this.blocks.every((b) => b.hasAttribute('data-empty-promo')));
  }
}
if (!customElements.get('univers-tabs')) customElements.define('univers-tabs', UniversTabs);
